<div id="menuIzq" style="position: fixed;" [style.left]="menuTopLeftPosition.x" [style.top]="menuTopLeftPosition.y"
    [matMenuTriggerFor]="rightMenu">
    <!-- standard material menu -->
    <mat-menu #rightMenu="matMenu">
        <ng-template matMenuContent let-item="item">

            <button mat-menu-item (click)="deleteArchivo()">
                <mat-icon class="iconoMenVer" [ngStyle]="{'color':'grey'}">delete</mat-icon>
                {{ 'gestion.seguimiento.actas.eliminar' | translate }}
            </button>
        </ng-template>
    </mat-menu>
</div>
<div class="workSpace">
    <!--nombre y filtro-->
    <div class="w3-container w3-container-template" style="height: 7%;">
        <!--Titulo de modulo y subtitulo-->
        <div class="w3-caja-menu padreizquierda w3-thirty">
            <div class="w3-row hijoizquierda centradoVertical">
                <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{
                        'menu.'+dataService.moduleSelect | translate }} </b></span>
                <span class="w3-text-deep-orange">&bull;</span>
                <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{
                    'menu.'+dataService.subModuleSelect | translate }} </span>
            </div>
        </div>
        <!--Filtros-->
        <div class="w3-caja-menu padreizquierda w3-center w3-rest" style="height: 100%">
            <!-- Filtros periodos  -->
            <div class="w3-quarter">
                <app-filters
                [name]="'filtros.periodo' | translate"
                [array]="periodos"
                [typeFilter]="Filters.PERIOD"
                (eventClick)="changePeriods($event)"
                [click]="false"
                />
            </div>
            <div class="w3-quarter">
                <app-filters
                [name]="'filtros.lider' | translate"
                [typeFilter]="Filters.SUCURSALES"
                (eventClick)="changeResponsibles($event)"
                [click]="false"
                [array]="viewResponsables"
                [consolidado]="viewAllresponsibles"
                />
            </div>
            <div class="w3-quarter">
                <app-filters
                [name]="'filtros.res' | translate"
                [typeFilter]="Filters.SUCURSALES"
                (eventClick)="changeResponsiblesActivity($event)"
                [click]="false"
                [array]="viewResponsablesActivity"
                [consolidado]="viewAllresponsiblesActivity"
                />
            </div>
            <div class="w3-rest padreizquierda w3-right">
                <div class="w3-row hijoizquierda">
                <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                    (click)="borrarFiltro()" style="transform: scale(0.9);" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
                    <img src="./../../../../assets/img/eraser.png">
                </div>
                </div>
            </div>
        </div>
    </div>
    <div class="w3-center tablero" id="componentGantt">
        <div class="w3-row menuTable">
            <div class="w3-row" style="margin-left: 5vh;">
                <mat-icon class="iconoMen" [matMenuTriggerFor]="menuTable">more_vert</mat-icon>
            </div>
            <mat-menu #menuTable="matMenu">
                <button mat-menu-item (click)="excelExport()">
                    {{ 'acciones.exportarExcel' | translate}}
                    <mat-icon>description</mat-icon>
                </button>
            </mat-menu>
        </div>
        <div class="w3-row tableContainer">
            @if (viewTablero) {
                <table class="w3-table">
                    <thead>
                        <tr class="w3-table-title">
                            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
                                {{'cues.planes-seguimiento.planes' | translate}}
                            </th>
                            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
                                {{'cues.proyectos.selec-responsible' | translate}}
                            </th>
                            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
                                {{'cues.planes-seguimiento.inicio' | translate}}
                            </th>
                            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
                                {{'cues.planes-seguimiento.dias' | translate}}
                            </th>
                            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
                                {{'cues.planes-seguimiento.fin' | translate}}
                            </th>
                            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
                                {{'cues.planes-seguimiento.estatus' | translate}}
                            </th>
                            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
                                {{'cues.planes-seguimiento.acumulado' | translate}}
                            </th>
                            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
                                {{'cues.planes-seguimiento.planeado' | translate}}
                            </th>
                            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
                                {{'cues.planes-seguimiento.ejecutado' | translate}}
                            </th>
                            @for (adicional of aditionals; track $index) {
                                <th class="encabezados 3-border-right-balance textoOverFlow" style="padding: 0vw 10px; cursor: pointer; line-height: 1.2;">
                                    <span>{{adicional.nombre}}</span>
                                </th>
                            }
                        </tr>
                    </thead>
                    @for (p of dataOrdenado; track p.id) {
                        <tbody>
                            <tr class="w3-table-trtd">
                                <td class="borderAllLow alinLeft anchosColC textoOverFlow" style="max-width: 30vw;">
                                    @if (!p.visible) {
                                        <mat-icon class="iconoMen"
                                        (click)="p.visible = !p.visible">expand_more</mat-icon>
                                    }@else {
                                        <mat-icon class="iconoMen"
                                        (click)="p.visible = !p.visible">expand_less</mat-icon>
                                    }
                                    <span [matTooltip]="p.name">{{p.name}}</span>
                                </td>
                                <td class="borderAllLow alinLeft anchosColC textoOverFlow" style="max-width: 30vw; padding-left: 1vw;">
                                    <span [matTooltip]="p.responsable?.role_name">{{p.responsable?.role_name}}</span>
                                </td>
                                <td class="borderAllLow alinCenter anchosColC">
                                    {{p.start_date | date:'dd/MM/yyyy'}}
                                </td>
                                <td class="borderAllLow alinCenter anchosColC">
                                    {{p.days}}
                                </td>
                                <td class="borderAllLow alinCenter anchosColC">
                                    {{p.end_date | date:'dd/MM/yyyy'}}
                                </td>
                                <td class="borderAllLow alinLeft anchosCol">

                                </td>
                                <td class="borderAllLow alinLeft anchosCol">

                                </td>
                                <td class="borderAllLow alinCenter anchosColC">
                                    {{getGoal(p.goals)['planned']}}
                                </td>
                                <td class="borderAllLow alinCenter anchosColC">
                                    {{getGoal(p.goals)['executed'] === null ? 0 : getGoal(p.goals)['executed']}}
                                </td>
                                @for (adicional of p.adicionales; track $index) {
                                    <td class="borderAllLow"> <br> </td>
                                }
                            </tr>
                            @if (p.visible) {
                                @for (a of p.activities; track a.id) {
                                    <tr class="w3-table-trtd">
                                        <td class="borderAllLow alinLeft anchosColC" style="padding-left: 2vw;">
                                            {{a.name}}
                                        </td>
                                        <td class="borderAllLow alinLeft anchosColC textoOverFlow" style="max-width: 30vw; padding-left: 1vw;">
                                            <span [matTooltip]="a.responsable?.role_name">{{a.responsable?.role_name}}</span>
                                        </td>
                                        <td class="borderAllLow alinCenter anchosColC">
                                            {{a.start_date | date:'dd/MM/yyyy'}}
                                        </td>
                                        <td class="borderAllLow alinCenter anchosColC">
                                            {{a.days}}
                                        </td>
                                        <td class="borderAllLow alinCenter anchosColC">
                                            {{a.end_date | date:'dd/MM/yyyy'}}
                                        </td>
                                        <td class="borderAllLow alinLeft anchosCol estatCol"
                                            [ngStyle]="{'color': getEstatus(a, 'c')}"
                                            style="padding-left: 1vw; font-weight: 600;">
                                            {{getEstatus(a)}}
                                        </td>
                                        <td class="borderAllLow alinCenter anchosCol estatCol" style="padding-left: 1vw;">
                                            {{getAcumulado(a)}}
                                        </td>
                                        <td class="borderAllLow alinCenter anchosColC">
                                            {{getGoal(a.goals)['planned']}}
                                        </td>
                                        <td class="borderAllLow alinCenter anchosColC" style="cursor: pointer;" (dblclick)="previewGoal(a.goals, a)">
                                            {{getGoal(a.goals)['executed'] === null ? '-' : getGoal(a.goals)['executed']}}
                                        </td>
                                        @for (adicional of p.adicionales; track $index) {
                                            @switch (adicional.tipo) {
                                                @case ('TEXT') {
                                                    <td class="borderAllLow" style="cursor: pointer;" (dblclick)="editAditional(adicional, a)"> {{writeAditional(adicional, a)}} </td>
                                                }
                                                @case ('FILE') {
                                                    <td class="borderAllLow alinCenter amchosColC">
                                                        @if (writeAditional(adicional, a) !== undefined) {
                                                            <div class="iconoArch" style="cursor: pointer;" (contextmenu)="onContextMenu($event, adicional, a)">
                                                                <mat-icon matTooltip="{{writeAditional(adicional, a)}}" class="iconoMen" [ngStyle]="{'color':'#4E9AC7'}"
                                                                 (dblclick)="openFile(writeAditional(adicional, a, true))">attach_file</mat-icon>
                                                            </div>
                                                        }@else {
                                                            <div class="iconoArch" style="cursor: pointer;" (dblclick)="editAditional(adicional, a)">
                                                                <mat-icon  matTooltip="{{'gestion.seguimiento.proy-estra.tooltipAdj' | translate}}" class="iconoMen" [ngStyle]="{'color':'#C8C7C8'}">attach_file</mat-icon>
                                                            </div>
                                                        } 
                                                    </td>
                                                }
                                            }
                                        }
                                    </tr>
                                }
                            }
                        </tbody>
                    }
                </table>
            }@else {
                <app-skeleton-table [columnas]="8" [filas]="15"/>
            }
        </div>
    </div>
</div>